import { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import PwaInstallPrompt from './components/PwaInstallPrompt';
import LoginPage from './pages/Login';
import RegisterPage from './pages/Register';
import AccountSettingsPage from './pages/AccountSettings';
import OrganizationsPage from './pages/Organizations';
import CreateOrganizationPage from './pages/CreateOrganization';
import OrganizationLayout from './pages/organization/OrganizationLayout';
import GasStationsLayout from './pages/organization/GasStationsLayout';
import NewGasStation from './pages/organization/gas-station/New';
import GasStationDashboard from './pages/organization/gas-station/Dashboard';
import GasStationInventory from './pages/organization/gas-station/Inventory';
import GasStationDeliveries from './pages/organization/gas-station/Deliveries';
import GasStationSettings from './pages/organization/gas-station/Settings';
import DeliveryDriversLayout from './pages/organization/DeliveryDriversLayout';
import NewDeliveryDriver from './pages/organization/delivery-driver/New';
import DeliveryDriverOverview from './pages/organization/delivery-driver/Overview';
import DeliveryDriverAssignments from './pages/organization/delivery-driver/Assignments';
import DeliveryDriverSettings from './pages/organization/delivery-driver/Settings';
import InviteCodesPage from './pages/organization/delivery-driver/InviteCodes';
import CustomersLayout from './pages/organization/CustomersLayout';
import CustomerDetail from './pages/organization/customer/Detail';
import NewCustomer from './pages/organization/customer/New';
import CustomerOverview from './pages/organization/customer/Overview';
import CustomerOrders from './pages/organization/customer/Orders';
import CustomerSettings from './pages/organization/customer/Settings';
import ProductsLayout from './pages/organization/ProductsLayout';
import NewProduct from './pages/organization/product/New';
import ProductDetail from './pages/organization/product/Detail';
import OrdersLayout from './pages/organization/OrdersLayout';
import OrderDetail from './pages/organization/order/Detail';
import NewOrder from './pages/organization/order/New';
import ReportsLayout from './pages/organization/ReportsLayout';
import ReportsDashboard from './pages/organization/reports/Dashboard';
import OrdersReportPage from './pages/organization/reports/Orders';
import RevenueReportPage from './pages/organization/reports/Revenue';
import DeliveriesReportPage from './pages/organization/reports/Deliveries';
import DeliveryTimeReportPage from './pages/organization/reports/DeliveryTime';
import SettingsPage from './pages/organization/Settings';
import MembersPage from './pages/organization/Members';

function App() {
  const location = useLocation();
  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'page_view', { page_path: location.pathname });
    }
  }, [location.pathname]);

  return (
    <>
    <PwaInstallPrompt />
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/account" element={<AccountSettingsPage />} />
      <Route path="/organizations" element={<OrganizationsPage />} />
      <Route path="/organizations/new" element={<CreateOrganizationPage />} />
      <Route path="/organizations/:id" element={<OrganizationLayout />}>
        <Route index element={<GasStationsLayout />} />
        <Route path="stations/new" element={<NewGasStation />} />
        <Route path="stations/:stationId" element={<GasStationsLayout />}>
          <Route index element={<GasStationDashboard />} />
          <Route path="inventory" element={<GasStationInventory />} />
          <Route path="deliveries" element={<GasStationDeliveries />} />
          <Route path="settings" element={<GasStationSettings />} />
        </Route>
        <Route path="drivers" element={<DeliveryDriversLayout />} />
        <Route path="drivers/new" element={<NewDeliveryDriver />} />
        <Route path="drivers/:driverId" element={<DeliveryDriversLayout />}>
          <Route index element={<DeliveryDriverOverview />} />
          <Route path="assignments" element={<DeliveryDriverAssignments />} />
          <Route path="settings" element={<DeliveryDriverSettings />} />
          <Route path="invite-codes" element={<InviteCodesPage />} />
        </Route>
        <Route path="customers" element={<CustomersLayout />} />
        <Route path="customers/new" element={<NewCustomer />} />
        <Route path="customers/:customerId" element={<CustomerDetail />}>
          <Route index element={<CustomerOverview />} />
          <Route path="orders" element={<CustomerOrders />} />
          <Route path="settings" element={<CustomerSettings />} />
        </Route>
        <Route path="products" element={<ProductsLayout />} />
        <Route path="products/new" element={<NewProduct />} />
        <Route path="products/:productId" element={<ProductDetail />} />
        <Route path="orders" element={<OrdersLayout />} />
        <Route path="orders/new" element={<NewOrder />} />
        <Route path="orders/:orderId" element={<OrderDetail />} />
        <Route path="reports" element={<ReportsLayout />}>
          <Route index element={<ReportsDashboard />} />
          <Route path="orders" element={<OrdersReportPage />} />
          <Route path="revenue" element={<RevenueReportPage />} />
          <Route path="deliveries" element={<DeliveriesReportPage />} />
          <Route path="delivery-time" element={<DeliveryTimeReportPage />} />
        </Route>
        <Route path="members" element={<MembersPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
      <Route path="/" element={<Navigate to="/organizations" replace />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
    </>
  );
}

export default App;
